module.exports = __webpack_public_path__ + "static/img/7.a4d444f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/1/sp/7.png
// module id = TzOD
// module chunks = 0